/**
 * Configure AXIOS JS
 * https://github.com/axios/axios
 *
 * This library automatically handles sending the CSRF token as a header based
 * on the value of the "XSRF" token cookie.
 */

import axios from 'axios'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common['X-Device-UUID'] = localStorage.getItem('UUID') ?? AndroidDevice.UUID()
axios.defaults.headers.common['Accept-Language'] = localStorage.getItem('locale') ?? 'en'
axios.defaults.timeout = 30000 // expressed in milliseconds
